import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo/LogoYellow.svg'
import _imports_1 from '@/assets/menu/Close.svg'


const _hoisted_1 = { class: "wrapper-header" }
const _hoisted_2 = { class: "content-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "logo"
      }, null, -1)),
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSession && _ctx.closeSession(...args)))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "",
          class: "icon-close"
        }, null, -1)
      ]))])
    ])
  ]))
}